module.exports = __webpack_public_path__ + "static/media/subICloud2.27828714.png";